const REJECT_ALL_BTN_SELECTOR = 'reject-recommended-btn-handler';

window.injectCookiesConsentRejectBtn = function injectCookiesConsentRejectBtn(btnLabel = 'Reject all') {
    if (!document.getElementById(REJECT_ALL_BTN_SELECTOR)) {
        // These are the JS actions linked to the button - e.g. rejecting the cookies and closing the banner.
        const actions = `Optanon.RejectAll(); Optanon.SetAlertBoxClosed(); document.getElementById('onetrust-banner-sdk').style.display = 'none';`;

        // This retrieves the container, and adds the button, with a few CSS amendments.
        const container = document.querySelector('#accept-recommended-container .ot-sdk-column');

        if (container) {
            const btn = document.createElement('button');
            btn.setAttribute('id', 'reject-recommended-btn-handler');
            btn.setAttribute('aria-label', 'Reject All');
            btn.setAttribute('role', 'button');
            btn.setAttribute('onclick', actions);
            btn.setAttribute('tabindex', 0);
            btn.textContent = btnLabel;

            container.appendChild(btn);
        }
    }
};
